registerComponent("sections/home-blog", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 3` / `slidesToScroll: 3`, `1` no celular,
 * `infinite: false`, `arrows` e `dots` apontando para o `blocks/slider-controls`
 * ao lado) vira um `Asa.trilho`. O passo continua sendo a JANELA inteira
 * (`passo: 'pagina'`, que é o `slidesToScroll === slidesToShow` do legado), e
 * quantos cabem por janela quem diz é o CSS — o trilho MEDE, não recebe.
 *
 * ⚠️ Nenhum `matchMedia` aqui. O degrau 3→1 mora no `_home-blog.less`, e o
 * trilho lê dele o `slidesToShow` e o `scroll-snap-type`; JS e CSS não podem
 * discordar por um pixel (é o descompasso 767/768 do legado, que aqui não
 * existe).
 */

const lista = component.querySelector('.slider');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-blog"]', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
}

});
